// Shared adminUserGroup-domain i18n keys (used by UserGroupListing, UserGroupModal).
// Page-level keys live under `UserGroupListing.*`, `UserGroupModal.*`.

export const adminUserGroupDict: Record<string, [en: string, th: string]> = {
  // ── Page titles / breadcrumbs ───────────────────────────
  "UserGroupListing.pageTitle": ["User Groups Management", "จัดการกลุ่มผู้ใช้"],
  "UserGroupListing.breadcrumb": ["User Groups", "กลุ่มผู้ใช้"],

  // ── UserGroupListing — page-level keys ─────────────────
  "UserGroupListing.search": ["Search Groups", "ค้นหากลุ่ม"],
  "UserGroupListing.column.name": ["Name", "ชื่อ"],
  "UserGroupListing.column.roles": ["Roles", "บทบาท"],
  "UserGroupListing.column.users": ["Users", "ผู้ใช้"],
  "UserGroupListing.column.status": ["Status", "สถานะ"],
  "UserGroupListing.column.createdAt": ["Created At", "วันที่สร้าง"],

  // ── UserGroupModal — page-level keys ───────────────────
  "UserGroupModal.title.create": ["Create User Group", "สร้างกลุ่มผู้ใช้"],
  "UserGroupModal.title.edit": ["Edit User Group", "แก้ไขกลุ่มผู้ใช้"],
  "UserGroupModal.field.name": ["Name", "ชื่อกลุ่ม"],
  "UserGroupModal.field.description": ["Description", "คำอธิบาย"],
  "UserGroupModal.field.role": ["Role", "บทบาท"],
  "UserGroupModal.field.permissions": ["Permissions", "สิทธิ์"],
  "UserGroupModal.field.active": ["Active", "เปิดใช้งาน"],
  "UserGroupModal.placeholder.groupName": ["Group name", "ระบุชื่อกลุ่ม"],
  "UserGroupModal.placeholder.selectRole": ["Select role", "เลือกบทบาท"],
  "UserGroupModal.placeholder.permissions": ["e.g. action:subject, comma separated", "เช่น action:subject คั่นด้วยคอมม่า"],
  "UserGroupModal.permissionsHint": ["Example: create:user, update:model", "ตัวอย่างเช่น create:user, update:model"],

  // ── Shared group status labels (used by UserGroupListing) ──
  "adminUserGroup.status.active": ["Active", "ใช้งานอยู่"],
  "adminUserGroup.status.inactive": ["Inactive", "ปิดใช้งาน"],
};
